import { Avatar, Card, Flex, Spin, theme, Typography } from "antd";
import React from "react";

const { Text } = Typography;
const { useToken } = theme;

interface BubbleAntdProps {
  content: React.ReactNode;

  placement?: "start" | "end";
  shape?: "round" | "square";
  loading?: boolean;

  styles?: {
    footer?: React.CSSProperties;
    content?: React.CSSProperties;
    container?: React.CSSProperties;
  };

  footer?: React.ReactNode | false;

  avatar?: {
    src?: string;
    icon?: React.ReactNode;
  };

  name?: string;
}

export const Bubble: React.FC<BubbleAntdProps> = ({
  content,

  placement = "start",
  shape = "round",
  loading = false,

  styles,
  footer,

  avatar,
  name,
}) => {
  const { token } = useToken();

  const isRight = placement === "end";

  return (
    <Flex
      justify={isRight ? "flex-end" : "flex-start"}
      style={{
        width: "100%",
        ...(styles?.container || {}),
      }}
    >
      <Flex
        gap={8}
        align="start"
        style={{
          maxWidth: "80%",
          flexDirection: isRight ? "row-reverse" : "row",
        }}
      >
        {/* Avatar */}
        {avatar && (
          <Avatar
            src={avatar.src}
            icon={avatar.icon}
            size={32}
            style={{
              flex: "0 0 auto",
              alignSelf: "flex-start",
            }}
          />
        )}

        {/* Conteúdo */}
        <Flex
          vertical
          gap={4}
        >
          {/* Nome */}
          {name && (
            <Text
              style={{
                fontSize: 12,
                color: token.colorTextSecondary,
                textAlign: isRight ? "right" : "left",
              }}
            >
              {name}
            </Text>
          )}

          {/* Bubble */}
          <Card
            size="small"
            styles={{
              body: {
                padding: "8px 12px",
                ...(styles?.content || {}),
              },
            }}
            style={{
              background: isRight ? token.colorPrimaryBg : token.colorFillTertiary,

              borderRadius: shape === "round" ? 12 : 4,

              borderTopRightRadius: isRight ? 0 : undefined,
              borderTopLeftRadius: isRight ? undefined : 0,

              border: "none",
            }}
          >
            {loading ? <Spin size="small" /> : <Text>{content}</Text>}
          </Card>

          {/* Footer */}
          {footer !== false && footer && <div style={{ ...(styles?.footer || {}) }}>{footer}</div>}
        </Flex>
      </Flex>
    </Flex>
  );
};
